export const GET_COMMENTS_START = 'GET_COMMENTS_START';
export const GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS';
export const GET_COMMENTS_ERROR = 'GET_COMMENTS_ERROR';
export const GET_COMMENTS_END = 'GET_COMMENTS_END';
export const GET_COMMENTS_CLEAR = 'GET_COMMENTS_CLEAR';
